<template>
  <svg viewBox="0 0 50.07 50.18">
    <g style="display: inline">
      <polygon
        points="6.01,6.11 6.01,44.17 7.01,44.17 7.01,7.11 44.09,7.11 44.09,6.11 	"
      />
      <path
        d="M26.13,26.49h14.05V12.43H26.13V26.49z M27.13,19.96h5.53v5.53h-5.53V19.96z M33.66,25.49v-5.53h5.53v5.53H33.66zM39.18,18.96h-5.53v-5.53h5.53V18.96z M32.66,13.43v5.53h-5.53v-5.53H32.66z"
      />
      <polygon
        points="18.47,16.63 20.8,18.96 9.5,18.96 9.5,19.96 20.8,19.96 18.47,22.29 19.17,23 22.72,19.46 19.17,15.92 	"
      />
      <rect x="23.86" y="12.37" width="1" height="14.19" />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconSuperisolerend extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #000000;
  stroke-miterlimit: 10;
}

.st1 {
  display: none;
}

.st2 {
  display: inline;
}

.st3 {
  fill: none;
  stroke: #29abe2;
  stroke-miterlimit: 10;
}
</style>
